// ===== Level 1 — Tendering main tabs =====
export const TENDERING_TAB_KEY_MAP = {
  1: 'boq',
  2: 'rfq',
  3: 'cba',
};

export const TENDERING_TABS = {
  boq: '1',
  rfq: '2',
  cba: '3',
};

// ===== Level 2 — BOQ sub-tabs =====
export const BOQ_TAB_KEY_MAP = {
  1: 'boq-packages',
  2: 'specifications',
};

export const BOQ_TABS = {
  'boq-packages': '1',
  // legacy slug redirect
  'boq-management': '1',
  specifications: '2',
};

// ===== Level 3 — BOQ Management sub-tabs =====
export const BOQ_MGMT_TAB_KEY_MAP = {
  1: 'ffne',
  2: 'osne',
};

export const BOQ_MGMT_TABS = {
  ffne: '1',
  osne: '2',
};

// ===== Level 2 — RFQ sub-tabs =====
export const RFQ_TAB_KEY_MAP = {
  1: 'create-rfq',
  2: 'issue-rfq',
  3: 'rfq-status',
  4: 'rfq-discussion',
  5: 'vendor-quotes',
};

export const RFQ_TABS = {
  'create-rfq': '1',
  'issue-rfq': '2',
  'rfq-status': '3',
  'rfq-discussion': '4',
  'vendor-quotes': '5',
  // legacy slug redirect
  'vendor-costing': '5',
};

// ===== Level 3 — CreateRFQ sub-tabs =====
export const CREATE_RFQ_SUBTAB_LABELS = {
  packages: 'Packages',
  pqq_documents: 'PQQ Documents',
  bid_questions: 'Bid Questions',
  evaluation_criteria: 'Evaluation Criteria',
  bid_info: 'Bid Info',
  tnc: 'T&C',
};

// ===== Level 2 — CBA sub-tabs =====
export const CBA_TAB_KEY_MAP = {
  1: 'summary',
  2: 'detail',
  3: 'scoring',
};

export const CBA_TABS = {
  summary: '1',
  detail: '2',
  scoring: '3',
};
